// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';



// CUSTOM 
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../SnackAlert';
import { timeToClosedToast } from '../../../commons';
import MultipleSnackbars from '../../MultipleSnackbars';
import { storeEditTipoNovedad } from '../../../store/tipo_novedad';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import { closeSessionGlobal, hasPemissions } from '../../../commons/utils';
import { EditTipoNovedad } from '../../tipoNovedades/editar/EditTipoNovedad';
import validationSchema from '../../tipoNovedades/formModels/editar/validationSchema';
import formInitialValues from '../../tipoNovedades/formModels/editar/formInitialValues';
import editTipoNovedadFormModel from '../../tipoNovedades/formModels/editar/editTipoNovedadFormModel';






const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));





/**
 * EditDialogTipoNovedad component is a modal dialog used for editing a "Tipo Novedad".
 * 
 * @param {object} props - The properties object.
 * @param {boolean} props.open - Determines if the modal is open or closed.
 * @param {function} props.handleCloseModalEditarTipoNovedad - Function to handle closing the modal.
 * @param {boolean} [props.buttons=false] - Optional property to show or hide buttons.
 * 
 * @returns {JSX.Element} The rendered EditDialogTipoNovedad component.
 * 
 * @example
 * <EditDialogTipoNovedad 
 *   open={isOpen} 
 *   handleCloseModalEditarTipoNovedad={handleClose} 
 *   buttons={true} 
 * />
 * 
 * @remarks
 * This component uses Formik for form handling and validation, and Redux for state management.
 * It includes various state hooks for managing alerts and session expiration.
 * 
 * @component
 * @category Modals
 */
export const EditDialogTipoNovedad = (props:any) =>  {


  // USE DISPATCH 
  const dispatch = useDispatch();


  // PROPS 
  const{ open, handleCloseModalEditarTipoNovedad, buttons = false } = props;


  // DATA FORM MODEL 
  const { formId, formField } = editTipoNovedadFormModel;


  // VALIDATION SCHEMA 
  const currentValidationSchema = validationSchema[0];

  

  // USE STATE 
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);



  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);
  
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });

  

  // CONST FUNCTIONS 
  const handleClose = () => {
    handleCloseModalEditarTipoNovedad(false);
  };


  const _handleSubmit = async(values:any, actions:any) => {



    const havePermissions = await hasPemissions('modulo.thumano', 'modulo.novedades', 'edit', 'modulo.tiponovedades');
    
    
      if( !havePermissions ){
        
          await validateLsPermissions('No tienes pemisos para (Editar) tipo novedad.');

          return false;                                                             
          
      }

    

    actions.setSubmitting(true);

    const response = await dispatch( storeEditTipoNovedad(values) );


    const result = await validateResponseCreate(response, ' (Editar Tipo Novedad.) ');
  

    if (!result) {
        return false;
    }


    if ( response.ok ) {

      const errors:any = {
        msg: response.message,
        status: 'success'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);

      actions.resetForm();
      actions.setSubmitting(false);
      handleCloseModalEditarTipoNovedad(false);

    }

    

  }
  

  const validateLsPermissions = async(message:string) => {

    const errors:any = {
      msg: message,
      status: 'error'
    };
  
    await setMsgSnack(errors);
    await setAlertSnack(true);
  
  
  }


  const validateResponseCreate = async(response:any, textActionConcat: string) => {
        
        
      if (  response.code == 401  ) {
        await localStorage.removeItem('lastSelectedQypht');
        await closeSessionGlobal();
        await handleCloseModalEditarTipoNovedad(false);
        setModalSessionExpired(true);
        return false;
      }

    
      // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
      if (!response.ok && response.code == 403 ) { 

      
        const errors:any = {
          msg: response.errors[0]+' '+textActionConcat,
          status: 'error'
        };
      
        await setMsgSnack(errors);
        await setAlertSnack(true);

      
        return false;
        
      }


      // 403 EL DATO YA SE ENCUENTRA REGISTRADO
      if (!response.ok && response.code == 409 ) { 
    
        const errors:any = {
            msg: response.errors[0]+' '+textActionConcat,
            status: 'error'
        };
        
        await setMsgSnack(errors);
        await setAlertSnack(true);

        return false;
      }

      
      // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
      if (!response.ok && response.code == 400 ) { 

        const errors:any = [];

        response.errors.forEach( (element:any) => {
            
            errors.push({
              type: 'error',
              text: element
            })
        });

          
        setMessagesAlerts(errors);
        return false;

      }

      return true;
    
  } 
  

  return (
    <React.Fragment>


      <ModalSessionExpired  open={modalSessionExpired}  />

      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />

      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth='md'
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Editar Tipo Novedad
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
        <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
              <Form id={formId}>
                <EditTipoNovedad formField={formField}/>

                <Button
                    // disabled={isSubmitting}
                    style={{margin:5, float: 'right'}}
                    type="submit"
                    variant="contained"
                    color={ "primary"}
                  >
                    Editar Tipo Novedad
                </Button>
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}




